// extracted by mini-css-extract-plugin
module.exports = {"idRow":"UserDetails__idRow___aqbg+"};